import BackendApi from '@/services/backend.service'
import { RequestError } from '@/services/errorHandler.service'

export interface FlowWriteResult {
  flow: Record<string, unknown>
  status: string
  published: boolean
  warning?: string
  validation_errors?: Array<Record<string, unknown> | string>
}

export interface CreateFlowPayload {
  whatsapp_api_sender_id: number
  name: string
  flow_json: string | Record<string, unknown>
  publish?: boolean
}

export interface UpdateFlowPayload {
  flow_json: string | Record<string, unknown>
  publish?: boolean
}

function assertSuccess(response: any) {
  if (!response?.data?.success) {
    throw new RequestError(response)
  }

  return response.data.data as FlowWriteResult
}

export async function createFlowFromJson(payload: CreateFlowPayload): Promise<FlowWriteResult> {
  const response = await BackendApi.post('/meta/whatsapp/flows', payload)
  return assertSuccess(response)
}

export async function updateFlowFromJson(waFlowId: number, payload: UpdateFlowPayload): Promise<FlowWriteResult> {
  const response = await BackendApi.put(`/meta/whatsapp/flows/${waFlowId}`, payload)
  return assertSuccess(response)
}

export async function publishFlowById(waFlowId: number): Promise<FlowWriteResult> {
  const response = await BackendApi.post(`/meta/whatsapp/flows/${waFlowId}/publish`)
  return assertSuccess(response)
}

export async function deactivateFlowById(waFlowId: number) {
  const response = await BackendApi.post(`/meta/whatsapp/flows/${waFlowId}/deactivate`)

  if (!response?.data?.success) {
    throw new RequestError(response)
  }

  return response.data.data
}

export async function updateFlowVisibleName(waFlowId: number, visibleName: string) {
  const response = await BackendApi.patch(`/meta/whatsapp/flows/${waFlowId}/visible-name`, {
    visible_name: visibleName
  })

  if (!response?.data?.success) {
    throw new RequestError(response)
  }

  return response.data.data
}

// Minimal template for JSON editor create mode.
export const emptyFlowTemplate = {
  version: '7.0',
  screens: [
    {
      id: 'SCREEN_A',
      title: 'Pantalla 1',
      data: {},
      terminal: true,
      layout: {
        type: 'SingleColumnLayout',
        children: [
          {
            type: 'Form',
            name: 'form',
            children: [
              {
                type: 'TextHeading',
                text: 'Título'
              },
              {
                type: 'Footer',
                label: 'Continuar',
                'on-click-action': {
                  name: 'complete',
                  payload: {}
                }
              }
            ]
          }
        ]
      }
    }
  ]
}
